import { Checkbox, RadioGroup } from "@tine/designsystem-ui-react";
import { AnimatePresence, motion } from "framer-motion";
import type React from "react";
import type { FilterSettings, LegalFilterKey } from "../../common/types/productTypes";
import { translateFilterValue } from "../../common/utils/filterUtils";
import productStore from "../../stores/product/productStore";

type FilterOptionsProps = {
   filters: FilterSettings[];
   onFilterChange: (e: React.ChangeEvent<HTMLInputElement>, field: LegalFilterKey, value: string, isRadio: boolean) => void;
};

const FilterOptions = ({ filters, onFilterChange }: FilterOptionsProps) => {
   return (
      <AnimatePresence>
         <motion.div
            key="filter-panel"
            className="tw-w-full tw-divide-x-0 tw-divide-y tw-divide-solid tw-divide-ink-border-subtle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
         >
            {filters.map((f) =>
               Object.keys(f.options).length > 0 ? (
                  <div key={f.name} className="tw-p-2 first:tw-pt-0 last:tw-pb-0">
                     <h4>{f.name}</h4>
                     {f.radioDefault ? (
                        <RadioGroup
                           label={""}
                           className="tw-text-sm"
                           value={productStore.activeFilters[f.field]?.[0] || f.radioDefault}
                           options={Object.keys(f.options)
                              .sort()
                              .map((optionName) => ({
                                 label: translateFilterValue(f.field, optionName),
                                 value: optionName
                              }))}
                           onChange={(e) => onFilterChange(e, f.field, e.target.value, !!f.radioDefault)}
                        />
                     ) : (
                        Object.keys(f.options)
                           .sort()
                           .map((optionName) => {
                              const name = translateFilterValue(f.field, optionName);

                              return (
                                 !!optionName && (
                                    <Checkbox
                                       key={optionName}
                                       className="tw-m-1 tw-text-sm tw-font-normal"
                                       label={name}
                                       isChecked={productStore.isFilterActive(f.field, optionName)}
                                       onChange={(e) => onFilterChange(e, f.field, optionName, !!f.radioDefault)}
                                    />
                                 )
                              );
                           })
                     )}
                  </div>
               ) : null
            )}
            {filters.length === 0 && <h4>Ingen filtre tilgjengelig</h4>}
         </motion.div>
      </AnimatePresence>
   );
};

export default FilterOptions;
